var o={OpenIDConnect:"OpenIDConnect",LDAP:"LDAP",Google:"Google"};export{o as SSOConfigurationType};
//# sourceMappingURL=types.js.map